
import { useEffect, useState } from "react"

import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Box, Paper, Tabs, Tab, Grid, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material"

import { Layout } from "../../../components/Layout"
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente"
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator"
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion"

import { TabProps, TabPanel } from "../../../helpers/TabPanel"

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Anexos } from "../ui/Anexos";
import { Asistentes } from "../ui/Asistentes";
import { Notificacion } from "../ui/Notificacion";
import { AcordarPromociones } from "../ui/AcordarPromociones";
import { InformacionAudiencia } from "../ui/InformacionAudiencia";

import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";

import { ActualizarEstatusAudiencia, DetalleAudiencia } from "../../../connections/audiencias/AudienciaConnection";

import { AnexoProps } from "../../../interfaces/comun/AnexoInterface";
import { NotificacionesProps } from "../../../interfaces/notificaciones/NotificacionesInterface";
import { AsistenteProps, AudienciaProps, defaultAudiencia, PromocionesProps } from "../../../interfaces/audiencias/AudienciaInterface";

const edit = false;

export const VisualizarActaAudienciaPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [value, setValue] = useState( 0 );

    const [audiencia, setAudiencia] = useState<AudienciaProps>( defaultAudiencia );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState(false);

    const [asistentes, setAsistentes] = useState<AsistenteProps[]>( [] );
    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );
    const [anexos, setAnexos] = useState<AnexoProps[]>( [] );
    const [promociones, setPromociones] = useState<PromocionesProps[]>( [] );

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => setValue( newValue )

    const handleFinalizar = async () => {

        setLoadingFinalizar( true )

        await ActualizarEstatusAudiencia({ idAudiencia: Id ?? '', idEstatus: audiencia.anexos.length !== 0 ? 36 : 3, }).then(resp => {

            const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

            if ( success ) {

                setTimeout(() => {

                    if ( audiencia.anexos.length !== 0 ) {

                        if ( asignadoMismoUsuario ) {

                            navigate(`/gestionar-audiencia/escanear-anexos/${ Id ?? ''}`);
                            setLoadingFinalizar( false );

                        }
                        else {

                            setProcesoTerminado( true );
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                            setLoadingFinalizar( false );

                        }

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');

                        setLoadingFinalizar( false );
                    }

                }, 700);

            }
            else {

                setTimeout(() => {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar(false);

                }, 700);

            }

        });

    }

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await DetalleAudiencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setAudiencia( resp );
                        setAsistentes( resp.asistentes );
                        setNotificaciones( resp.notificaciones );
                        setAnexos( resp.anexos );
                        setPromociones( resp.promociones );

                        if ( resp.idEstatus === 3 ) {

                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.idEstatus === 4 ) {

                            setProcesoCancelado( true );
                            setLoading( false );

                        }
                        else if ( !resp.asignadoMismoUsuario ) {

                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 35 ) {

                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );

                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 35 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Gestionar audiencia' }, { text: 'Autorizar acta de audiencia' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ audiencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Acta de audiencia" {...TabProps(0)} />
                                        <Tab label="Información de la audiencia" {...TabProps(1)} />
                                        <Tab label="Asistentes en la audiencia" {...TabProps(2)} />
                                        <Tab label="Notificación" {...TabProps(3)} />
                                        <Tab label="Anexo(s)" {...TabProps(4)} />
                                        <Tab label="Acordar promociones" {...TabProps(5)} />
                                        <Tab label="Información del expediente" {...TabProps(6)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion numeroSeguimiento={ `GAU-${ audiencia.idAudiencia }` } fecha={ audiencia?.fecha ?? new Date() } />

                                        <Grid container spacing={ 3 } mt={ 3 }>

                                            <Grid size={ { md: 12, xs: 12 } }>

                                                {
                                                    audiencia.documento
                                                    &&
                                                        <iframe
                                                            title='iframe-documento'
                                                            style={ { width: '100%', height: 800, borderRadius: 8 } }
                                                            src={ audiencia.documento }
                                                        />
                                                }

                                            </Grid>

                                            <Grid size={ { md: 12, xs: 12 } } sx={ { mt: 3 } }>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={ { md: 4, xs: 12 } } sx={ { textAlign: 'right' } }> </Grid>

                                                    <Grid size={ { md: 4, xs: 12 } } sx={ { textAlign: 'center' } }>

                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={ { md: 4, xs: 12 } } style={ { textAlign: 'left' } }> </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <InformacionAudiencia
                                            audiencia={ audiencia }
                                            edit={ edit }
                                        />

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <Asistentes
                                        audiencia={ audiencia }
                                        asistentes={ asistentes }
                                        setAsistentes={ setAsistentes }
                                        partes={ audiencia.expediente.partes }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <Notificacion
                                        audiencia={ audiencia }
                                        notificaciones={ notificaciones }
                                        setNotificaciones={ setNotificaciones }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <Anexos
                                        audiencia={ audiencia }
                                        anexos={ anexos }
                                        setAnexos={ setAnexos }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <AcordarPromociones
                                        audiencia={ audiencia }
                                        promociones={ promociones }
                                        setPromociones={ setPromociones }
                                        edit={ edit }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 6 }>

                                    <BoxInformacionExpediente expediente={ audiencia.expediente } />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='sm'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => {} }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la visualización de la acta de audiencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>

                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                        <Button variant='contained' loading={ loadingFinalizar } onClick={ handleFinalizar }> Aceptar </Button>

                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
